<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-xs text-gray-500">
      <a role="button" class="underline" @click.prevent="showContact">
        {{ fullName }}
      </a>
      <div class="mt-1">
        <span
          v-if="typeof contact.unsubscribe_request_id === 'string'"
          class="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800"
          >{{ $t('global.unsubscribed') }}</span
        >
      </div>
    </td>
    <td class="px-4 py-4 text-xs text-gray-500">
      <span v-if="contact.primary_email_address">
        {{ contact.primary_email_address.address }}
      </span>
      <div class="mt-1">
        <span
          v-if="
            contact.primary_email_address &&
            typeof contact.primary_email_address.unsubscribe_request_id === 'string'
          "
          class="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800"
          >{{ $t('global.unsubscribed') }}</span
        >
      </div>
    </td>
    <td class="px-4 py-4 text-xs text-gray-500">
      <span v-if="contact.primary_phone_number">
        {{ contact.primary_phone_number.number }}
      </span>
      <div class="mt-1">
        <span
          v-if="
            contact.primary_phone_number &&
            typeof contact.primary_phone_number.unsubscribe_request_id === 'string'
          "
          class="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800"
          >{{ $t('global.unsubscribed') }}</span
        >
      </div>
    </td>
    <td class="px-4 py-4 text-xs text-gray-500">
      {{ assigneeFullName }}
    </td>
    <td
      v-if="$membershipHasPermissionTo('read contact requests')"
      class="px-4 py-4 text-xs text-gray-500"
    >
      {{ contact.contact_requests_count }}
    </td>
    <td
      v-if="$membershipHasPermissionTo('read acc orders')"
      class="px-4 py-4 text-xs text-gray-500"
    >
      {{ contact.acc_orders_count }}
    </td>
    <td class="px-4 py-4 text-xs text-gray-500">
      <span class="whitespace-nowrap">
        {{ createdAtShort }}
      </span>
      <p>
        {{ createdAtFromNow }}
      </p>
    </td>
  </tr>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fullName() {
      if (typeof this.contact?.full_name === 'string') {
        return this.contact.full_name;
      }

      return `${this.contact?.first_name || ''} ${this.contact?.last_name || ''}`.trim();
    },
    assigneeFullName() {
      if (!this.contact.user_id) {
        return this.$t('global.unassigned');
      }

      return this.contact?.user?.fullName || this.$t('global.not_available');
    },
    createdAt() {
      return moment.utc(this.contact.created_at).local();
    },
    createdAtShort() {
      return this.createdAt.format('DD-MM-YYYY');
    },
    createdAtFromNow() {
      return this.createdAt.fromNow();
    },
  },
  methods: {
    showContact() {
      this.$modal.show({
        component: 'ContactModal',
        props: {
          contactId: this.contact.id,
        },
        on: {
          'contact-deleted': (contact) => {
            this.$emit('contact-deleted', contact);
          },
          'contact-updated': () => {
            this.$emit('contact-updated');
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
